// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"c0c4f0ca","787":"ca1d8c8f"}[chunkId] + ".chunk.js";
};